<template>
    <div class="landing-page-template-container">
        <div class="join-us-modal-container" v-show="showJoinUs">
            <div class="join-us-modal">
                <div class="join-us-close" @click="toggleJoinUs()"><span class="icon"><img :src="`/Assets/img/cancel.svg`" /></span></div>
                <div class="join-us-sections">
                    <div class="join-us-section-header">
                        Join {{settings.siteNameCaps}}
                    </div>
                    <a class="join-us-section" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" target="_blank" @click="trackEvent('whatsapp')" v-if="whatsapp">
                        <div class="join-us-icon"><img :src="`/assets/img/logo-whatsapp.png`"></div>
                        <div class="join-us-text">JOIN OUR WHATAPP GROUP</div>
                    </a>
                    <a class="join-us-section" :href="settings.socialLinks.facebook" target="_blank" @click="trackEvent('facebook')" v-if="facebook">
                        <div class="join-us-icon"><img :src="`/assets/img/logo-facebook.jpg`"></div>
                        <div class="join-us-text">JOIN US ON FACEBOOK</div>
                    </a>
                    <a class="join-us-section" @click="openNewsletterModal()" v-if="email">
                        <div class="join-us-icon"><img :src="`/assets/img/daily-deals.png`"></div>
                        <div class="join-us-text">DAILY DEALS EMAIL</div>
                    </a>
                    <a class="join-us-section" :href="settings.socialLinks.instagram" target="_blank" @click="trackEvent('instagram')" v-if="instagram">
                        <div class="join-us-icon"><img :src="`/assets/img/logo-instagram.jpg`"></div>
                        <div class="join-us-text">FOLLOW US ON INSTAGRAM</div>
                    </a>
                    <a class="join-us-section" :href="settings.socialLinks.twitter" target="_blank" @click="trackEvent('twitter')" v-if="twitter">
                        <div class="join-us-icon"><img :src="`/assets/img/logo-twitter.jpg`"></div>
                        <div class="join-us-text">FOLLOW US ON TWITTER</div>
                    </a>
                </div>
            </div>
        </div>
        <div v-if="!seperateImageAndText" class="landing-page-image-container2 landing-page-image-additional" :style="topBannerStyle">
            <div class="landing-page-image-text-container" v-if="showCtaButton">
                <div class="landing-page-image-text" v-html="topBannerText">

                </div>
                <div class="landing-page-image-button" >

                    <a v-if="straightToWhatsapp" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" class="button button-get-started" target="_blank">{{ctaButtonText}}</a>
                    <button v-if="!straightToWhatsapp" class="button button-get-started" @click="toggleJoinUs()">{{ctaButtonText}}</button>

                </div>
            </div>
        </div>
        <div v-if="seperateImageAndText" class="seperate-image-and-text">




            <div class="landing-page-image-container2 landing-page-image-additional" :style="topBannerStyle">

            </div>
            <div class="landing-page-slogan-container" v-if="showCtaButton">
                <div class="landing-page-slogan-text" v-html="topBannerText">

                </div>
                <div class="landing-page-slogan-button" >

                    <a v-if="straightToWhatsapp" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" class="button button-get-started" target="_blank">{{ctaButtonText}}</a>
                    <button v-if="!straightToWhatsapp" class="button button-get-started" @click="toggleJoinUs()">{{ctaButtonText}}</button>

                </div>
            </div>
        </div>
        <div class="landing-page-how-it-works-container" v-if="showHowItWorks">
            <div class="landing-page-logo">
                <img :src="settings.logoUrl">
            </div>
            <div class="landing-page-how-it-works-text">
                How it Works
            </div>
            <div class="landing-page-boxes">
                <div class="landing-page-box">
                    <div class="landing-page-box-icon">1</div>
                    <div class="landing-page-box-title">{{howItWorks.one.title}}</div>
                    <div class="landing-page-box-text">{{howItWorks.one.text}}</div>
                </div>
                <div class="landing-page-box">
                    <div class="landing-page-box-icon">2</div>
                    <div class="landing-page-box-title">{{howItWorks.two.title}}</div>
                    <div class="landing-page-box-text">{{howItWorks.two.text}}</div>
                </div>
                <div class="landing-page-box">
                    <div class="landing-page-box-icon">3</div>
                    <div class="landing-page-box-title">{{howItWorks.three.title}}</div>
                    <div class="landing-page-box-text">{{howItWorks.three.text}}</div>
                </div>
            </div>
            <div class="landing-page-how-it-works-button">

                <a v-if="straightToWhatsapp" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" class="button button-get-started" target="_blank">{{ctaButtonText}}</a>
                <button v-if="!straightToWhatsapp" class="button button-get-started" @click="toggleJoinUs()">{{ctaButtonText}}</button>

            </div>
        </div>
        <div class="landing-page-slogan-container">
            <div class="landing-page-slogan-text" v-html="bottomBannerText">

            </div>
            <div class="landing-page-slogan-button">
                <a v-if="straightToWhatsapp" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" class="button button-get-started" target="_blank">{{ctaButtonText}}</a>
                <button v-if="!straightToWhatsapp" class="button button-get-started" @click="toggleJoinUs()">{{ctaButtonText}}</button>
            </div>
        </div>
        <div v-if="showDeals">
            <Deals :showJoinUs="true" :showPrice="true" />
        </div>

        <div class="contact-us-info-container" v-if="settings.contactPhone || settings.contactEmail">
            <div class="title">Contact Us</div>
            <div class="info-wrapper">
                <div class="info-container" v-if="settings.contactEmail">
                    <div class="info-label">Email</div>
                    <div class="info-data">{{settings.contactEmail}}</div>
                </div>
                <div class="info-container" v-if="settings.contactPhone">
                    <div class="info-label">Phone</div>
                    <div class="info-data">{{settings.contactPhone}}</div>
                </div>
            </div>
        </div>

        <component :is="'style'">
            {{additionalStyle}}
        </component>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, inject } from 'vue'
import { useRoute } from 'vue-router'
import settings from '@/settings'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'
import Deals from '@/components/Deals.vue'
import type { NewsletterParams } from '@/plugins/newsletter/types'

const route = useRoute()
const showNewsletter = inject<(params: NewsletterParams) => void>('showNewsletter')

// State
const showJoinUs = ref<boolean>(false)
const showBottomBanner = ref<boolean>(false)
const topBannerStyle = ref<string | null>(null)
const topBannerText = ref<string | null>(null)
const bottomBannerText = ref<string | null>(null)
const seperateImageAndText = ref<boolean>(false)
const straightToWhatsapp = ref<boolean>(false)
const whatsappLink = ref<string | null>(null)
const whatsapp = ref<boolean>(true)
const facebook = ref<boolean>(true)
const email = ref<boolean>(true)
const showDeals = ref<boolean>(false)
const twitter = ref<boolean>(true)
const instagram = ref<boolean>(true)
const additionalStyle = ref<string>('')
const showCtaButton = ref<boolean>(true)
const showHowItWorks = ref<boolean>(true)
const ctaButtonText = ref<string>('Get Started')
const giveaway = ref<string | null>(null)

const howItWorks = ref({
    one: {
        title: 'Join the Fun',
        text: 'Join us on your favorite social channel - WhatsApp, Facebook, or Instagram'
    },
    two: {
        title: 'Receive Deals',
        text: 'We find relevant deals and share them directly with you'
    },
    three: {
        title: 'You Save',
        text: 'Save valuable money on great family oriented products from all over the web'
    }
})

// Methods
const toggleJoinUs = () => {
    trackEvent('getstarted')

    if (giveaway.value) {
        openNewsletterModal()
    } else {
        showJoinUs.value = !showJoinUs.value
    }
}

const trackEvent = (action: string): void => {
    ga.event(action, { 'event_category': 'landing', 'event_label': route.params.landing, 'transport_type': 'beacon' })
    clicky.log(action, 'click')
}

const openNewsletterModal = () => {
    if (showNewsletter) {
        showNewsletter({ giveaway: giveaway.value || undefined })
    }
}

// Lifecycle hooks
onMounted(() => {
    switch (route.params.landing as string) {
        case 'goldwater':
            showBottomBanner.value = true
            topBannerStyle.value = `background-image: url('${settings.siteImageFolder + 'goldwater1.jpg'}'); `
            topBannerText.value = `Welcome Alyssa Goldwater followers!<br> It's time to meet MommyDeals!`
            bottomBannerText.value = `Being a mom is a full-time job.<br> MommyDeals is here to help!`
            additionalStyle.value = `.landing-page-image-additional { color: yellow }`
            break
        case 'save':
            showBottomBanner.value = true
            topBannerStyle.value = `background-image: url('${settings.siteImageFolder + 'baby1.jpg'}');
                                    height: 300px;
                                    background-size: contain;
                                    background-attachment: inherit;`
            topBannerText.value = `Ready to save money during quarantine?`
            bottomBannerText.value = `Being a mom is a full-time job.<br> MommyDeals is here to help!`
            additionalStyle.value = `.landing-page-image-additional { color: yellow }`
            seperateImageAndText.value = true
            break
        case 'smartmom':
            showBottomBanner.value = true
            topBannerStyle.value = `background-image: url('${settings.siteImageFolder + 'smartmom.jpg'}');
                                    background-position-y: 0;
                                    background-size: contain;
                                    background-attachment: inherit;
                                    height: 275px;
                                    `
            topBannerText.value = `This mom is using our WhatsApp group to save money!`
            bottomBannerText.value = `Being a mom is a full-time job.<br> MommyDeals is here to help!<br><br> Shop our Deals!`
            additionalStyle.value = `.landing-page-image-additional { color: yellow }`
            seperateImageAndText.value = false
            whatsapp.value = true
            facebook.value = false
            email.value = false
            twitter.value = false
            instagram.value = false
            straightToWhatsapp.value = true
            showDeals.value = true
            showCtaButton.value = false
            whatsappLink.value = '/JoinWhatsapp'
            showHowItWorks.value = false
            break
        case 'giveaway500':
            showBottomBanner.value = true
            topBannerStyle.value = `background-image: url('${settings.siteImageFolder + 'giveaway500.jpg'}'); `
            topBannerText.value = `Sign up for our $500 giveaway!`
            bottomBannerText.value = `Being a mom is a full-time job.<br> MommyDeals is here to help!`
            additionalStyle.value = `.landing-page-image-additional { color: yellow }`
            giveaway.value = 'giveaway500'
            ctaButtonText.value = 'Sign Up'
            howItWorks.value = {
                one: {
                    title: 'Sign Up',
                    text: 'Signup by join our daily deals email blast.'
                },
                two: {
                    title: 'Get More Entries',
                    text: 'Share our giveaway with your friends to get more entries'
                },
                three: {
                    title: 'You Win',
                    text: 'You could win a $500 amazon giftcard'
                }
            }
            break
        default:
            showBottomBanner.value = true
            topBannerStyle.value = `background-image: url('${settings.siteImageFolder + 'mom_running2.jpg'}');`
            topBannerText.value = 'Being a mom is a full-time job.<br> MommyDeals is here to help!'
            bottomBannerText.value = "Remember, you're not <i>just</i> a Mom<br> You're a Domestic Engineer!"
            additionalStyle.value = ``
            break
    }
})
</script>

<style>
</style>